import { render } from "./CustomTextAreaField.vue?vue&type=template&id=5b239892&scoped=true"
import script from "./CustomTextAreaField.vue?vue&type=script&lang=js"
export * from "./CustomTextAreaField.vue?vue&type=script&lang=js"

import "./CustomTextAreaField.vue?vue&type=style&index=0&id=5b239892&lang=stylus&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b239892"]])

export default __exports__